var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveAddOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.89998C7.52647 3.89998 3.89998 7.52647 3.89998 12C3.89998 16.1324 6.99538 19.5433 10.9936 20.0382C11.4869 20.0992 11.8373 20.5486 11.7762 21.0419C11.7152 21.5352 11.2658 21.8856 10.7725 21.8245C5.88371 21.2194 2.09998 17.0522 2.09998 12C2.09998 6.53236 6.53236 2.09998 12 2.09998C17.0519 2.09998 21.2188 5.88317 21.8244 10.7715C21.8855 11.2647 21.5352 11.7142 21.0419 11.7753C20.5486 11.8364 20.0992 11.486 20.0381 10.9928C19.5428 6.99494 16.1321 3.89998 12 3.89998Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.89998C9.73561 7.89998 7.89998 9.73561 7.89998 12C7.89998 13.8087 9.07172 15.346 10.7 15.8899C11.1715 16.0473 11.426 16.5572 11.2685 17.0286C11.1111 17.5001 10.6012 17.7546 10.1298 17.5971C7.7891 16.8154 6.09998 14.6061 6.09998 12C6.09998 8.7415 8.7415 6.09998 12 6.09998C14.5989 6.09998 16.8032 7.77983 17.5906 10.1104C17.7498 10.5813 17.497 11.092 17.0261 11.2511C16.5552 11.4103 16.0445 11.1575 15.8854 10.6866C15.3375 9.06524 13.8037 7.89998 12 7.89998Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 18C23 15.2386 20.7614 13 18 13C15.2386 13 13 15.2386 13 18C13 20.7614 15.2386 23 18 23C20.7614 23 23 20.7614 23 18ZM17.1722 15.2361C17.2204 14.8217 17.5726 14.5 18 14.5C18.4602 14.5 18.8333 14.8731 18.8333 15.3333V17.1666H20.6666L20.7638 17.1722C21.1783 17.2204 21.5 17.5726 21.5 18C21.5 18.4602 21.1269 18.8333 20.6666 18.8333H18.8333V20.6666L18.8277 20.7638C18.7796 21.1783 18.4273 21.5 18 21.5C17.5397 21.5 17.1666 21.1269 17.1666 20.6666V18.8333H15.3333L15.2361 18.8277C14.8217 18.7796 14.5 18.4273 14.5 18C14.5 17.5397 14.8731 17.1666 15.3333 17.1666H17.1666V15.3333L17.1722 15.2361Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12C14 13.1045 13.1045 14 12 14C10.8954 14 9.99998 13.1045 9.99998 12C9.99998 10.8954 10.8954 9.99998 12 9.99998C13.1045 9.99998 14 10.8954 14 12Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveAddOutline);
export default __webpack_public_path__ + "static/media/live_add_outline.104acc7a538a8aa9d0b7e86c23f116d2.svg";
export { ForwardRef as ReactComponent };